import React, {useContext} from 'react';

// components
import Page from '../../components/Page';
//contexts
import PageContext from "../../contexts/Page";

//style
import "./Contact.scss";

const Contact = () => {

  const { pageData } = useContext(PageContext);

  return (
    <Page>
      <h2>{pageData?.tytul}</h2>
    </Page>
  );
};



export default Contact;